import axios from 'axios';
const api = process.env.REACT_APP_SERVER_API;

export default ()=>{
    return axios.create({
        baseURL: api + '/parkings'
    })
}